"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Item = _interopRequireDefault(require("../../../../../../../../Announcements/Item"));
var _SubMenu = require("../../../../../../SubMenu/SubMenu.style");
const AnnouncementsListItem = _ref => {
  let {
    isOpen,
    announcement,
    index,
    listLength,
    itemWidth
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItem
  // @ts-ignore
  , {
    showing: isOpen,
    noHover: true
    // @ts-ignore
    ,
    itemWidth: itemWidth,
    key: announcement.id,
    noRoundedCorners: true,
    "data-test-class": "announcement",
    "data-test-id": announcement.id
  }, /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItemInner, {
    showing: isOpen,
    bigVerticalPadding: true,
    listLength: listLength,
    index: index
  }, /*#__PURE__*/_react.default.createElement(_Item.default, announcement)));
};
var _default = exports.default = AnnouncementsListItem;